import { Component } from '@angular/core';
import { ListLoaderPreloaded } from 'app/shared/components/list-loader/list-loader-preloaded';
import {
  FieldMetaData,
  PersonStammListEntryMeta,
  PersonStammMasterDetailEntryMeta,
  PersonStammSearchResponseMeta
} from 'app/core/personstamm-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AbstractComponent } from 'app/shared/components/abstract-component/abstract.component';
import { TableSortModel } from 'app/shared/tablesort/tableSortModel';
import { ComparatorService } from 'app/shared/services/comparator-service';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentHeaderComponent } from '../../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../../shared/components/title-functionbar/title-functionbar.component';
import { FunctionbarSearchresultButtonsComponent } from '../../../../shared/components/title-functionbar/functionbar-searchresult-buttons/functionbar-searchresult-buttons.component';
import { ListLoaderWrapperComponent } from '../../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { ColumnHeaderComponent } from '../../../../shared/tablesort/sort-icon/column-header.component';
import { LinkComponent } from '../../../../shared/components/link/link.component';
import { KompaktPersonenadresseComponent } from '../../../../shared/kompaktdarstellung/personenadresse/kompakt-personenadresse.component';
import { CapSpinnerSmallComponent } from '../../../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { TranslatePipe } from '@ngx-translate/core';
import { FormatAhvPipe } from '../../../../shared/pipes/format/format-ahv.pipe';
import { FormatUidPipe } from '../../../../shared/pipes/format/format-uid.pipe';
import { YesNoPipe } from '../../../../shared/pipes/simple/yes-no.pipe';
import { PermissionResponse } from '../../../../core/base-api';
import { AppPermissionService } from '../../../../core/services/app-permission.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-person-search-result',
  templateUrl: './person-search-result.component.html',
  styleUrls: ['./person-search-result.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    FunctionbarSearchresultButtonsComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    NgbTooltip,
    ColumnHeaderComponent,
    LinkComponent,
    KompaktPersonenadresseComponent,
    CapSpinnerSmallComponent,
    TranslatePipe,
    FormatAhvPipe,
    FormatUidPipe,
    YesNoPipe
  ]
})
export class PersonSearchResultComponent extends AbstractComponent {
  personLoader: ListLoaderPreloaded<PersonStammListEntryMeta>;
  personResponse: PersonStammSearchResponseMeta;
  detailNavigationPossible: boolean;
  hasPermissionAuskunft: boolean = false;
  hasPermissionAdresse: boolean = false;

  tableSortModel = new TableSortModel<PersonStammListEntryMeta>('table', this.comparatorService);

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    private comparatorService: ComparatorService,
    private permissionService: AppPermissionService
  ) {
    super();
    keysToTranslate<string>([
      'personstamm.ListTitel',
      'personstamm.GrundbuchBezug',
      'zentraleNr',
      'tooltip.detailsPersonZpv',
      'AHV-Nr/UID',
      'zpvService.nichtVerfuegbar',
      'zpv.MaximalResultWarning'
    ]);
    this.tableSortModel
      .addColumn('bezeichnung', (a, b) => this.comparatorService.translatedStringComparator(a.bezeichnung, b.bezeichnung), null)
      .switchSortDirection();
    this.tableSortModel.addColumn('art', (a, b) => this.comparatorService.translatedStringComparator(a.art, b.art), null);
    this.tableSortModel.addColumn('ahvNummer', (a, b) => this.comparatorService.translatedStringComparator(a.ahvNummer, b.ahvNummer), null);
    this.tableSortModel.addColumn(
      'zentraleNummer',
      (a, b) => this.comparatorService.translatedStringComparator(a.fremdId, b.fremdId),
      null
    );
    this.tableSortModel.addColumn(
      'bezugGb',
      (a, b) =>
        this.comparatorService.translatedStringComparator(a.mitGrundbuchbezug ? 'true' : 'false', b.mitGrundbuchbezug ? 'true' : 'false'),
      null
    );

    this.addSub(
      this.route.data.subscribe((data) => {
        this.personResponse = data.entity;
        this.detailNavigationPossible = this.personResponse.results[0].mFremdId.access === FieldMetaData.AccessEnum.ALLOWED;
        this.personLoader = new ListLoaderPreloaded<PersonStammListEntryMeta>(
          15,
          1,
          this.personResponse.results,
          this.personResponse.recordsFound
        );
        this.personLoader.applySortModel(this.tableSortModel);
      })
    );
    this.hasPermissionAuskunft = this.permissionService.hasPermission(PermissionsEnum.AUSKUNFTSPERRE);
    this.hasPermissionAdresse = this.permissionService.hasPermission(PermissionsEnum.ADRESSSPERRE);
  }

  hasAdresssperre(auskunftsperre: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum): boolean {
    return auskunftsperre === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.ADRESS_SPERRE;
  }

  hasAuskunftsperre(auskunftsperre: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum): boolean {
    return auskunftsperre === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.AUSKUNFT_SPERRE;
  }

  showPersonendaten(auskunftsperre: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum): boolean {
    return !this.hasAuskunftsperre(auskunftsperre) || (this.hasAuskunftsperre(auskunftsperre) && this.hasPermissionAuskunft);
  }
}
